import { render, staticRenderFns } from "./FormSucursal.vue?vue&type=template&id=6841963e&"
import script from "./FormSucursal.vue?vue&type=script&lang=js&"
export * from "./FormSucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports